import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef } from 'react';
import _ from 'lodash';
import BaseModal from 'components/BaseModal';
import { LoadingIcon } from 'components/Icons';
import message from "components/CustomMessage";

function SnykOAuthPopup({ afterClose: _afterClose, ...props }, ref) {
    const isEdit = !_.isUndefined(props?.id)
    const errorRef = useRef(false);
    const failedStatusRef = useRef(true);
    const thisRef = useRef();
    //login id is used in Mapping Form Modal once OAuth login is successful
    const loginIdRef = useRef();
    const params = new URLSearchParams();
    if(isEdit){
        params.append("state", props.id);
    }
    if(props.autoOnboardProjects){
        params.append("autoOnboardProjects", props.autoOnboardProjects);
    }
    if(props.ingestSBOM){
        params.append("ingestSBOM", props.ingestSBOM);
    }
    if(props.apiEndpoint){
        params.append("apiEndpoint", props.apiEndpoint)
    }
    const URL = `/user/tools/snyk/oauth2/redirect?${params.toString()}`;
    useImperativeHandle(ref,() => ({
        ...thisRef
    }))

    const afterClose = useCallback(() => {
        _afterClose && _afterClose(failedStatusRef.current, loginIdRef.current);
    }, [_afterClose]);

    useEffect(() => {
        const _window = window.open(URL, "_blank", "width=1000,height=800,rel=noopener");
        if(_.isNull(_window)){
            message.error("Pop-up window is blocked on your browser, please enable and retry.");
            afterClose()
            return false;
        }
        const timer = setInterval(function() { 
            try {
                // _window becomes null if the popup window is blocked by the browser.
                // User closes the OAuth window before access
                if(!_window || _window.closed) {
                    clearInterval(timer);
                    message.error("Unable to connect to Snyk, please try again.");
                    thisRef.current.close();
                    return;
                }
                if(_window.location.pathname.endsWith("oauth2")){
                    const bodyText = JSON.parse(_window.document.body.innerText);
                    const closeModal = () => {
                        _window.close();
                        thisRef.current.close();
                        clearInterval(timer);
                    };
                    if(bodyText.id){
                        loginIdRef.current = bodyText.id;
                        failedStatusRef.current = false;
                        closeModal();
                        return;
                    } else if(errorRef.current){
                        closeModal();
                    }
                }
            } catch (e) {errorRef.current = true}
        }, 1000);
        return () => {
            clearInterval(timer);
            _window.close();
        }
    }, [afterClose, URL]);

    return (
        <BaseModal
            modalProps={{
                title: "Connecting Snyk OAuth",
                footer: null
            }}
            ref={thisRef}
            afterClose={afterClose}
        >
            <LoadingIcon /> Waiting for Snyk OAuth.
        </BaseModal>
    )
}

export default forwardRef(SnykOAuthPopup);